import * as Types from '../constants/actionTypes';

export default (state = {processesList: [],pageData:[]}, action) => {
    switch (action.type) {
        case Types.PROCESSES_DETAIL_SUCCESS:
            return Object.assign({}, state, {
                 processesList: action.payload?.data || [],
                 pageData:action.payload?.pageData, 
                 isPanding: false })
        case Types.PROCESSES_ADDED_SUCCESS:
            state.processesList.push(action.payload)
            return {
                ...state
            }

        case Types.PROCESSES_DELETED_SUCCESS:
            state.processesList.splice(action.deleteIndex,1)
            return {
                ...state
            }
        case Types.PROCESSES_UPDATE_SUCCESS:
            state.processesList[action.updateIndex] = action.payload
            return {
                ...state
            }
        case Types.PROCESSING_PARTNER_ERROR:
           return {
                partnerError: action.partnerError
            }
        case Types.PROCESSING_PARTNER_UPLOAD_ERROR:
            return {
                partnerUploadError:action.error
            }
        case Types.PROCESSING_PARTNER_LIST_COUNT_SUCCESS:
            return {
                processingPartnerListCount: action.payload
            }
        case Types.PROCESSING_PARTNER_UPLOAD_SUCCESS:
            return {
                uploadSuccessmessage: action.payload
            }
        default:
            return state
    }
}


